import { MessageBox } from "@rothoblaas/design-system";
import { FC, memo } from "react";
import useI18n from "../../../hooks/useTranslations";
import { UILanguageCode } from "../../../types";
import styles from "./ConcreteResinDetailInstructionsAndNotes.module.css";

// Rothoblaas' website in the user's language: rothoblaas.com for English, rothoblaas.<language> otherwise.
const getRothoblaasDomain = (languageCode: UILanguageCode): string =>
  `www.rothoblaas.${languageCode === "en" ? "com" : languageCode}`;

const ConcreteResinDetailInstructionsAndNotes: FC = () => {
  const i18n = useI18n();

  const domain = getRothoblaasDomain(i18n.translation.languageCode);
  const href = `https://${domain}`;

  return (
    <div className={styles.content}>
      {/* in one warning: the product ETA's hole filling the estimate rests on, how to inject the
          resin, the disclaimer and where to find the latest design resources */}
      <MessageBox
        type="warning"
        className={styles.warning}
        content={
          <p className={styles.summary}>
            {i18n.translation.concreteResinModule.instructionsSummaryPrefix}{" "}
            <a href={href} target="_blank" rel="noopener">
              {domain}
            </a>
            {i18n.translation.concreteResinModule.instructionsSummarySuffix}
          </p>
        }
      />
      {/* how to inject the resin: from the bottom of the hole, without trapping air */}
      <img
        src="/concreteResin/instructions-resin-application.svg"
        alt={i18n.translation.concreteResinModule.titleInstructionsAndNotes}
        className={styles.image}
      />
    </div>
  );
};

export default memo(ConcreteResinDetailInstructionsAndNotes);
